// External
import { useI18n } from "Hooks";
import { connect } from "react-redux";
import React, { useCallback, useRef } from "react";

// Internal
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { MicrophoneOutlined } from "@toddle-edu/ds-icons";
import { getSpeechToTextTranscript } from "modules/Services";
import AudioRecorderSelector from "UIComponents/AudioRecorderSelector";

const AIPanelVoiceToText = ({
  testId,
  isDisabled,
  entityType,
  isTranscribing,
  conversationId,
  setIsTranscribing,
  onTranscriptionReceived,
  getSpeechToTextTranscript,
}) => {
  const { t } = useI18n();
  const recordButtonRef = useRef(null);

  const handleTranscription = useCallback(
    async ({ attachment }) => {
      setIsTranscribing(true);

      const payload = { entityId: conversationId, entityType };
      payload.blobAttachment = attachment;

      try {
        const transcript = await getSpeechToTextTranscript(payload);
        if (transcript?.transcript && onTranscriptionReceived) {
          onTranscriptionReceived(transcript?.transcript);
        }
      } catch (error) {}

      setIsTranscribing(false);
    },
    [
      entityType,
      conversationId,
      onTranscriptionReceived,
      getSpeechToTextTranscript,
    ]
  );

  const handleBlobAttachmentReceived = useCallback(
    async blobAttachment => {
      await handleTranscription({ attachment: blobAttachment });
    },
    [handleTranscription]
  );

  return (
    <AudioRecorderSelector
      version="inline"
      showValue={false}
      showProgress={false}
      parentId={conversationId}
      parentType="AI_CONVERSATION"
      recordButtonRef={recordButtonRef}
      disabled={isDisabled || isTranscribing}
      header={t("common:add_voice_message")}
      onBlobAttachmentRecieved={handleBlobAttachmentReceived}
      buttonComponent={
        <Tooltip showArrow={true} tooltip={t("common:record_message")}>
          <IconButton
            type="plain"
            size="medium"
            dsVersion="2.0"
            variant="neutral"
            ref={recordButtonRef}
            icon={<MicrophoneOutlined />}
            testId={`${testId}-aiPanelVoiceToText`}
            disabled={isDisabled || isTranscribing}
          />
        </Tooltip>
      }
    />
  );
};

export default connect(null, { getSpeechToTextTranscript })(AIPanelVoiceToText);
